import styled, { createGlobalStyle, css } from 'styled-components';

export const StyledMobileNotSupportedWrapper = styled.span<{
  $isUnsupportedScreenSize: boolean;
}>`
  display: ${props => (props.$isUnsupportedScreenSize ? 'inline' : 'none')};
`;

export const StyledOutletWrapper = styled.span<{
  $isUnsupportedScreenSize: boolean;
}>`
  display: ${props => (props.$isUnsupportedScreenSize ? 'none' : 'inline')};
`;

export const StyledGlobalPortals = createGlobalStyle<{
  $isUnsupportedScreenSize: boolean;
}>`
  ${({ $isUnsupportedScreenSize }) =>
    $isUnsupportedScreenSize &&
    css`
      #portal {
        display: none;
      }
    `}
`;
